import { ReactNode } from 'react';
import styled from 'styled-components';
import ThemeColors from "../../config/themeColors";

const H1 = styled.h1`
    text-align: center;
    font-weight: 300;
    font-size: 27px;
    color: ${ThemeColors.ftgOrange};
    padding-top: .1em;
    @media(max-width: 480px) {
        font-size: 22px;
    }
`

interface Props {
    children: ReactNode
}

const PageTitle = ({children}: Props) => (

    <H1>{children}</H1>
);

export default PageTitle;